<sam4-first-page-layout>
    <h1 class="text-danger" style="padding-top:12px;">Knowledge Base<br>&nbsp;&nbsp;Access Denied</h1>
    <a routerLink="/">Sign In</a>
    <sam4-google-auth-button></sam4-google-auth-button>
</sam4-first-page-layout>




